<template>
  <div class="research-report">
    <ReportRatings class="section-margin" />
    <TargetPriceForecast class="section-margin" />
    <ReportDigest />
  </div>
</template>

<script>
import ReportRatings from '@/components/report/ReportRatings.vue'
import TargetPriceForecast from '@/components/report/TargetPriceForecast.vue'
import ReportDigest from '@/components/report/ReportDigest.vue'
export default {
  components: { ReportRatings, TargetPriceForecast, ReportDigest }
}
</script>

<style lang="scss" scoped></style>
